import { logger } from '@ahaslides-product/frontend-toolkit'

const LOG_MESSAGE = 'audience load time'
const FEATURES_LOADED_MUTATION = 'featureToggles/setFeatures'

const round = (value) => (typeof value === 'number' ? Math.round(value) : undefined)

const readNavigationType = (performanceApi) => {
  const [entry] = performanceApi.getEntriesByType?.('navigation') || []
  return entry?.type
}

const readDevice = (navigatorApi) => {
  const connection = navigatorApi.connection || {}
  return {
    deviceMemoryGb: navigatorApi.deviceMemory,
    hardwareConcurrency: navigatorApi.hardwareConcurrency,
    connectionType: connection.effectiveType,
    connectionRttMs: connection.rtt,
    connectionDownlinkMbps: connection.downlink,
  }
}

export const buildAudienceLoadEntry = ({
  marks, accessCode, presentationId, navigationType, device,
}) => ({
  screen: 'audience',
  durationMs: round(marks.ready),
  navigationType,
  accessCode,
  presentationId,
  presentationReceivedMs: round(marks.presentationReceived),
  audienceJoinedMs: round(marks.audienceJoined),
  firstSlideMs: round(marks.firstSlide),
  ...device,
})

export const createAudienceLoadTelemetry = ({
  logFn = logger.extend('audienceLoad'),
  performanceApi = window.performance,
  navigatorApi = window.navigator,
  afterPaint = (callback) => window.requestAnimationFrame(() => window.requestAnimationFrame(callback)),
} = {}) => {
  const marks = {}
  let storeRef = null
  let finished = false
  let pendingEntry = null

  const markOnce = (name) => {
    if (marks[name] === undefined) marks[name] = performanceApi.now()
  }

  const emit = (entry) => {
    if (!logFn.enabled) return false
    logFn(LOG_MESSAGE, null, entry)
    return true
  }

  const onMutation = (mutation) => {
    if (mutation.type === 'setPresentation') markOnce('presentationReceived')
    else if (mutation.type === 'setAudienceId' && mutation.payload) markOnce('audienceJoined')
    else if (mutation.type === 'setSlide' && mutation.payload?.id) markOnce('firstSlide')
    else if (mutation.type === FEATURES_LOADED_MUTATION && pendingEntry && emit(pendingEntry)) pendingEntry = null
  }

  const plugin = (store) => {
    storeRef = store
    store.subscribe(onMutation)
  }

  const reportReady = (accessCode) => {
    if (finished || marks.presentationReceived === undefined) return
    finished = true
    afterPaint(() => {
      marks.ready = performanceApi.now()
      const entry = buildAudienceLoadEntry({
        marks,
        accessCode,
        presentationId: storeRef?.state?.presentation?.id,
        navigationType: readNavigationType(performanceApi),
        device: readDevice(navigatorApi),
      })
      if (!emit(entry)) pendingEntry = entry
    })
  }

  return { plugin, reportReady }
}

const audienceLoadTelemetry = createAudienceLoadTelemetry()

export const audienceLoadTelemetryPlugin = audienceLoadTelemetry.plugin
export const reportAudienceLoadReady = audienceLoadTelemetry.reportReady
